import { Font } from "@react-pdf/renderer";

/**
 * Регистрирует шрифты Roboto для использования в PDF документах
 * @returns Название семейства шрифтов ("Roboto" или "Helvetica" как fallback)
 */
export const registerPdfFonts = (): string => {
  let fontFamily = "Helvetica"; // Fallback на встроенный шрифт

  try {
    Font.register({
      family: "Roboto",
      fonts: [
        // Regular (400) - используем Medium, так как Regular отсутствует
        {
          src: "/fonts/Roboto-Medium.ttf",
          fontWeight: 400,
        },
        // Medium (500) - доступен в public/fonts/
        {
          src: "/fonts/Roboto-Medium.ttf",
          fontWeight: 500,
        },
        // Bold (700) - доступен в public/fonts/
        {
          src: "/fonts/Roboto-Bold.ttf",
          fontWeight: 700,
        },
      ],
    });
    fontFamily = "Roboto";
  } catch (error) {
    // Если файлы отсутствуют или произошла ошибка, используем встроенный шрифт
    console.warn(
      "Не удалось загрузить шрифты Roboto из public/fonts/. Используется Helvetica.",
      "Убедитесь, что файлы Roboto-Medium.ttf и Roboto-Bold.ttf находятся в public/fonts/",
      error,
    );
    fontFamily = "Helvetica";
  }

  return fontFamily;
};
